import React from 'react'
import Menu from "../../components/globalComponents/headerMenu/menu"
import SocialIcons from "../../components/globalComponents/socialIcons/socialIcons";
import GradientLine from "../../components/globalComponents/gradientLine/gradientLine";
import Footer from "../../components/globalComponents/footer/footer";

import "./productsPage.scss"

import ContactUs from '../../components/companyInfoComponents/contactUs/contactUs';
import getProdustosProyectosServicios from '../../components/productComponent/produstosProyectosServicios';
import Services from '../../components/productComponent/services/services';

const { productos, servicios, proyectos } = getProdustosProyectosServicios();

const ProductsPage = () => {

    return (
        <>
            <Menu />
            <div className='productPage__container'>
                <Services data={servicios} tipo="servicios" />
                <hr className="divider" />
                <Services data={productos} tipo="productos" />
                <hr className="divider" />
                <Services data={proyectos} tipo="proyectos" />
                <hr className="divider" />
            </div>
            <ContactUs />
            <SocialIcons />
            <GradientLine />
            <Footer />

        </>

    )
}

export default ProductsPage;